import { createContext, ReactNode, useContext } from 'react';

export type RightPanelContextValues = {
    rightPanelContent: ReactNode | null;
    setRightPanelContent: (content: ReactNode | null) => void;
};

const defaultContext: RightPanelContextValues = {
    rightPanelContent: null,
    setRightPanelContent: () => {},
};

export const RightPanelContext = createContext<RightPanelContextValues>(defaultContext);

export const useRightPanelContext = () => useContext(RightPanelContext);
